import Router from 'next/router';

const universalRedirect = (context, target, statusCode = 301) => {
  if (context.res) {
    if (!context.res.headersSent) {
      // On the server-side we need to redirect the response.
      context.res.redirect(statusCode, target);
    }
  } else {
    // On the client-side we can leverage the Next.js Router.
    Router.replace(target);
  }
};

export default universalRedirect;
